import React from 'react';
import { ShieldIcon, TrophyIcon } from 'lucide-react';
interface PricingProps {
  title?: string;
  compact?: boolean;
}
export function Pricing({
  title = 'ELEGÍ TU KIT',
  compact = false
}: PricingProps) {
  const basicCheckoutUrl = 'https://www.toolsuniverso.shop/cart/42991104327757:1';
  const completeCheckoutUrl = 'https://www.toolsuniverso.shop/cart/42991107735629:1';
  return <section id="pricing" className="py-16 px-4 sm:px-6 lg:px-8" data-id="element-131">
      <div className="max-w-5xl mx-auto" data-id="element-132">
        {title && <h2 className="text-3xl sm:text-4xl font-bold text-center mb-12 text-[#1A1A1A]" data-id="element-133">
            {title}
          </h2>}

        <div className="grid md:grid-cols-2 gap-8" data-id="element-134">
          {/* Basic Kit */}
          <div className={`bg-white border border-[#EAE5DC] shadow-sm rounded-lg overflow-hidden hover:shadow-md transition-all ${compact ? 'p-6' : 'p-8'}`} data-id="element-135">
            <div className="flex items-center gap-2 mb-4" data-id="element-136">
              <ShieldIcon className="w-6 h-6 text-[#6B9BD1]" data-id="element-137" />
              <h3 className={`font-bold text-[#1A1A1A] ${compact ? 'text-lg' : 'text-xl'}`} data-id="element-138">
                KIT DE SUPERVIVENCIA FISCAL
              </h3>
            </div>
            <p className={`text-[#6B7280] mb-4 ${compact ? 'text-sm' : ''}`} data-id="element-139">
              3 Tomos + 1 Bonus
            </p>

            {!compact && <p className="text-[#1A1A1A] font-medium mb-6 text-sm" data-id="element-140">
                Ideal para: Monotributistas que quieren operar con seguridad y
                sin sorpresas de AFIP
              </p>}

            <div className="mb-6" data-id="element-141">
              <div className="text-[#E85D5D] line-through text-lg mb-1 font-medium" data-id="element-142">
                $38.000
              </div>
              <div className="text-4xl font-bold text-[#1A1A1A]" data-id="element-143">
                $19.990 <span className="text-xl text-[#6B7280]" data-id="element-144">ARS</span>
              </div>
            </div>

            <a href={basicCheckoutUrl} className="block w-full text-center py-3 bg-[#5BB4A0] hover:bg-[#4A9382] text-white font-bold rounded-lg transition-colors shadow-sm" data-id="element-145">
              → QUIERO MI KIT AHORA
            </a>
          </div>

          {/* Complete Kit - Featured */}
          <div className={`bg-white border-2 border-[#F0C040] shadow-md rounded-lg overflow-hidden relative hover:scale-105 transition-all ${compact ? 'p-6' : 'p-8'}`} data-id="element-146">
            <div className="absolute top-0 right-0 bg-[#F0C040] text-[#1A1A1A] px-4 py-1 text-xs font-bold rounded-bl-lg" data-id="element-147">
              MÁS POPULAR
            </div>

            <div className="flex items-center gap-2 mb-4 mt-2" data-id="element-148">
              <TrophyIcon className="w-6 h-6 text-[#F0C040]" data-id="element-149" />
              <h3 className={`font-bold text-[#1A1A1A] ${compact ? 'text-lg' : 'text-xl'}`} data-id="element-150">
                KIT COMPLETO + MANUAL DEL REINTEGRO ⭐
              </h3>
            </div>
            <p className={`text-[#6B7280] mb-4 ${compact ? 'text-sm' : ''}`} data-id="element-151">
              3 Tomos + 1 Bonus + Manual del Reintegro
            </p>

            {!compact && <p className="text-[#1A1A1A] font-medium mb-6 text-sm" data-id="element-152">
                Ideal para: El que quiere defender su plata Y recuperar hasta
                $80.000 por mes de lo que ya le retuvieron
              </p>}

            <div className="mb-6" data-id="element-153">
              <div className="text-[#E85D5D] line-through text-lg mb-1 font-medium" data-id="element-154">
                $48.000
              </div>
              <div className="text-4xl font-bold text-[#5BB4A0]" data-id="element-155">
                $24.990 <span className="text-xl text-[#4A9382]" data-id="element-156">ARS</span>
              </div>
            </div>

            <a href={completeCheckoutUrl} className="block w-full text-center py-3 bg-[#5BB4A0] hover:bg-[#4A9382] text-white font-bold rounded-lg transition-colors shadow-md" data-id="element-157">
              → QUIERO EL KIT COMPLETO
            </a>
          </div>
        </div>
      </div>
    </section>;
}